<template>
  <div>
    <v-card
      color="#1F7087"
      dark
      :to="`/memoru/album/${album.albumId}`"
      height="300px"
      class="pa-2"
    >
      <v-img :src="album.thumbnailImage.url || ''" sizes="200px" height="180px">
      </v-img>
      <v-card-title>
        <v-row>
          <v-col cols="1" class="d-flex justify-center">
            <v-icon size="x-small" start :color="available ? `success` : `error`"
              >mdi-circle</v-icon
            >
          </v-col>
          <v-col>
            <h5 style="white-space: normal; word-break: break-word; line-height: 1.4;">
              {{ album.title }}
            </h5>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        {{ album.comment || "" }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { MultimediaAlbumResponse } from "chaild-api/lib";
import dayjs from "dayjs";

export default defineComponent({
  name: "MemoruAlbumCard",

  props: {
    album: {
      type: Object as () => MultimediaAlbumResponse,
      default: null,
    },
  },

  computed: {
    available: function (): boolean {
      if (this.album) {
        if (
          dayjs().isAfter(this.album.availableAfter) &&
          (!this.album.availableBefore ||
            dayjs().isBefore(this.album.availableBefore))
        ) {
          return true;
        }
        return false;
      }
      return true;
    },
  },
});
</script>
